import { myralisTokens } from './tokens';

const isGuestSignInCard = (card: HTMLElement) => {
  const text = card.textContent ?? '';

  return (
    text.includes('Enter as a Guest User') ||
    (text.includes('Guest') && text.includes('verified identity')) ||
    card.closest('.myralis-sign-in-page') !== null
  );
};

const setImportant = (element: HTMLElement, property: string, value: string) => {
  element.style.setProperty(property, value, 'important');
};

const applyLoginCardTheme = () => {
  const cards = Array.from(
    document.querySelectorAll<HTMLElement>(
      "[class*='MuiCard-root'], [class*='MuiPaper-root']",
    ),
  ).filter(isGuestSignInCard);

  for (const card of cards) {
    setImportant(card, 'background', myralisTokens.colors.surface);
    setImportant(card, 'background-color', myralisTokens.colors.surface);
    setImportant(card, 'color', myralisTokens.colors.text);
    setImportant(card, 'border', `1px solid ${myralisTokens.colors.border}`);
    setImportant(card, 'box-shadow', myralisTokens.shadow.subtle);

    for (const element of Array.from(
      card.querySelectorAll<HTMLElement>(
        "[class*='MuiCardContent-root'], [class*='MuiCardContent-root'] *, [class*='MuiCardActions-root'], [class*='MuiCardActions-root'] *, [class*='MuiCardContent-root'] p",
      ),
    )) {
      setImportant(element, 'background', myralisTokens.colors.surface);
      setImportant(element, 'background-color', myralisTokens.colors.surface);
      setImportant(element, 'color', myralisTokens.colors.text);
    }

    for (const header of Array.from(
      card.querySelectorAll<HTMLElement>(
        "[class*='MuiCardHeader-root'], [class*='CardHeader']",
      ),
    )) {
      setImportant(header, 'background', myralisTokens.colors.primary);
      setImportant(header, 'background-color', myralisTokens.colors.primary);

      for (const child of Array.from(header.querySelectorAll<HTMLElement>('*'))) {
        setImportant(child, 'background', 'transparent');
        setImportant(child, 'background-color', 'transparent');
        setImportant(child, 'color', myralisTokens.colors.white);
      }
    }

    for (const button of Array.from(
      card.querySelectorAll<HTMLElement>("button, [class*='MuiButton-root']"),
    )) {
      const label =
        button.querySelector<HTMLElement>("[class*='MuiButton-label']") ?? button;

      if (!label.textContent?.trim() || label.textContent.trim() === 'Sign In') {
        label.textContent = 'Entrar';
        button.setAttribute('aria-label', 'Entrar com Microsoft Entra');
      }

      setImportant(button, 'background', myralisTokens.colors.green);
      setImportant(button, 'background-color', myralisTokens.colors.green);
      setImportant(button, 'border-color', myralisTokens.colors.green);
      setImportant(button, 'color', myralisTokens.colors.institutionalBlue);

      for (const child of Array.from(button.querySelectorAll<HTMLElement>('*'))) {
        setImportant(child, 'background', 'transparent');
        setImportant(child, 'background-color', 'transparent');
        setImportant(child, 'color', myralisTokens.colors.institutionalBlue);
      }
    }
  }
};

if (typeof document !== 'undefined') {
  const observer = new MutationObserver(applyLoginCardTheme);

  const startObserver = () => {
    applyLoginCardTheme();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
}
